import type { ReactNode } from "react";

export interface CtaSubtitleProps {
  children: ReactNode;
}

/**
 * El párrafo bajo el título del CTA. `max-w-xl` + `mx-auto` es lo que
 * evita que en escritorio la frase se estire a todo el ancho del bloque y
 * se vuelva una línea imposible de seguir con la vista.
 */
export function CtaSubtitle({ children }: CtaSubtitleProps) {
  return (
    <p className="mx-auto mt-4 max-w-xl text-[14px] leading-relaxed text-white/70">
      {children}
    </p>
  );
}
